<script setup>
// Ayarlar bolumunun kabugu.
//
// Baglantilar sekmesi jetonlari yonetir. Jeton yokken reklam hesabi listesi de
// gelmez; o sekmede hesap secici gizlensin diye hesapGerekli rotaya gore
// hesaplaniyor. Kabuk hesaplari yalnizca baglanirken yukledigi icin, sekme
// degisip hesap yeniden gerektiginde listenin tazelenmesi adina :key ile
// yeniden olusturuluyor.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import MetaAdsKabuk from './MetaAdsKabuk.vue';

const { t } = useI18n();
const route = useRoute();

const sekmeler = computed(() => [
  { ad: t('META_ADS.AYARLAR.SEKME.BAGLANTILAR'), rota: 'meta_ads_baglantilar' },
  { ad: t('META_ADS.AYARLAR.SEKME.ISLETME'), rota: 'meta_ads_isletme' },
  { ad: t('META_ADS.AYARLAR.SEKME.TAKIP'), rota: 'meta_ads_takip' },
  {
    ad: t('META_ADS.AYARLAR.SEKME.MARKA_GUVENLIGI'),
    rota: 'meta_ads_marka_guvenligi',
  },
  {
    ad: t('META_ADS.AYARLAR.SEKME.WHATSAPP'),
    rota: 'meta_ads_whatsapp_araclari',
  },
]);

const hesapGerekli = computed(() => route.name !== 'meta_ads_baglantilar');
</script>

<template>
  <MetaAdsKabuk
    :key="hesapGerekli ? 'hesapli' : 'hesapsiz'"
    :baslik="t('META_ADS.AYARLAR.BASLIK')"
    :sekmeler="sekmeler"
    :hesap-gerekli="hesapGerekli"
  />
</template>
